import { Component, OnInit, Input } from '@angular/core';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { TrainersService } from '../../../services/trainers.service';

import { CommentComponent } from '../../modals/comment/comment.component';
import { EventsService } from '../../../services/events.service';

@Component({
  selector: 'app-trainer-comments',
  templateUrl: './trainer-comments.component.html',
  styleUrls: ['./trainer-comments.component.scss']
})
export class TrainerCommentsComponent implements OnInit {

  @Input() trainer;
  meta: {
    loading: boolean,
    saving: boolean,
    results: {
      currentPage: number,
      pageSize: number,
      lastPage: number,
      totalResult: number
    }
  };

  constructor(
    private modalService: NgbModal,
    private notification: ToastrService,
    private trainersService: TrainersService,
    private eventsService: EventsService
  ) { }

  ngOnInit() {
    this.meta = {
      loading: false,
      saving: false,
      results: {
        currentPage: null,
        pageSize: null,
        lastPage: null,
        totalResult: null
      }
    };

    this.loadResults(this.trainer.trainerId);
  }

  loadResults = (trainerId, page = 1) => {
    console.log(trainerId, page);
    this.meta.loading = true;
    this.trainer.comments = [];
    this.trainersService.getTrainerComments({trainerId: trainerId}, page).subscribe(
      res => {
        this.trainer.comments = res.data;
        this.meta.results = {
          currentPage: res.current_page,
          pageSize: res.per_page,
          lastPage: res.last_page,
          totalResult: res.total
        };
        this.meta.loading = false;
      },
      err => {
        this.notification.error(`Could't get the Trainer Comments: ${this.eventsService.getApiErrorMessage(err)}`, 'Error!');
        this.meta.loading = false;
      }
    );
  }

  openComment = (id) => {
    const modalWindow = this.modalService.open(CommentComponent, { centered: true, backdrop: 'static', size: 'lg'});
    modalWindow.componentInstance.comment = {id};
    modalWindow.result.then((result) => {
      console.log(`[ DEBUG ] Modal Closed with payload`, result);
    }, (reason) => {
      console.log(`[ DEBUG ] Modal dismissed: ${reason}`);
      if (reason === 'comment deleted') {
        this.loadResults(this.trainer.trainerId, this.meta.results.currentPage);
      }
    });
  }

}
